<div class="common-table">
	<p-toolbar *ngIf="options().showHeader">
		<div class="toolbar-left ">
			<ng-content select="[table-title]"></ng-content>
			@if(options().enabledFilterGloblal) {
			<p-iconfield class="w-100">
				<p-inputicon class="pi pi-search"></p-inputicon>
				<input pInputText inputClass="w-full" type="text" [value]="globalFilterValue()"
					(input)="onGlobalFilter($event)" placeholder="Buscar" />
			</p-iconfield>
			}
		</div>
		<div class="toolbar-right">
			<button  pButton type="button" icon="pi pi-refresh" severity="secondary" class="p-button-text"
				(click)="onActionClick('refresh'); loadData()" pTooltip="Recargar datos"></button>
			<button *ngIf="options().showBtnImport" pButton type="button" icon="pi pi-upload" class="p-button-text"
				(click)="onActionClick('import')"></button>
			<button *ngIf="options().showBtnExport" pButton type="button" icon="pi pi-download" class="p-button-text"
				label="Export a CSV" (click)="onActionClick('export')"></button>
			<button *ngIf="options().showBtnAdd" pButton severity="info" type="button" icon="pi pi-plus"
				[label]="'Añadir ' + env.features.fincaName" (click)="onActionClick('add')"></button>
		</div>
	</p-toolbar>

	<p-table #dt [value]="data()" [columns]="visibleColumns()" [paginator]="options().paginator"
		[loading]="request()?.isLoading" [rows]="options().rows" [rowsPerPageOptions]="options().rowsPerPageOptions"
		[globalFilterFields]="globalFilterFields()" [selectionMode]="tableSelectionMode()"
		[selection]="selectionValue()" [dataKey]="options().dataKey" [rowHover]="options().rowHover"
		[tableStyle]="{ 'min-width': '75rem' }" (selectionChange)="onSelectionChange($event)">
		<ng-template pTemplate="header" let-columns>
			<tr>
				<th *ngIf="showCheckboxes()" class="selection-col">
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th *ngFor="let col of columns" [pSortableColumn]="col.sortable !== false ? col.field : null"
					[style.width]="col.width" [ngClass]="col.headerClass">
					<div class="d-flex justify-content-center w-full align-items-center">
						<span>{{ col.header }}</span> &nbsp;
						<p-sortIcon *ngIf="col.sortable !== false" [field]="col.field"></p-sortIcon>
					</div>
				</th>
				<th *ngIf="showRowActions()" class="actions-col text-center">Acciones</th>
			</tr>
			<tr *ngIf="options().enabledFilterColumn">
				<th *ngIf="showCheckboxes()"></th>
				<th *ngFor="let col of columns">
					<input *ngIf="col.filterable !== false" pInputText type="text"
						[placeholder]="col.filterPlaceholder || 'Filtrar'"
						(input)="onColumnFilter($event, col.field)" />
				</th>
				<th *ngIf="showRowActions()"></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rowData let-columns="columns">
			<tr [pSelectableRow]="rowData">
				<td *ngIf="showCheckboxes()">
					<p-tableCheckbox [value]="rowData"></p-tableCheckbox>
				</td>
				<td *ngFor="let col of columns" [ngClass]="col.bodyClass" class="text-truncate" [style.width]="col.width ?? 1">
					{{ formatCell(rowData, col) }}
				</td>
				<td *ngIf="showRowActions()" class="actions-col text-center">
					<button *ngIf="options().showBtnView" pButton severity="info" type="button" icon="pi pi-eye"
						class="p-button-text" pTooltip="Mas información" tooltipPosition="top"
						(click)="onActionClick('view', rowData)"></button>
					<button *ngIf="options().showBtnEdit" pButton pTooltip="Editar" tooltipPosition="top" type="button" severity="warn" icon="pi pi-pencil"
						class="p-button-text" (click)="onActionClick('edit', rowData)"></button>
					<button *ngIf="options().showBtnDuplicate" pButton pTooltip="Duplicar" tooltipPosition="top" type="button" icon="pi pi-clone"
						class="p-button-text" (click)="onActionClick('duplicate', rowData)"></button>
					<button *ngIf="options().showBtnDelete" pButton pTooltip="Eliminar" tooltipPosition="top" type="button" icon="pi pi-trash"
						class="p-button-text p-button-danger" (click)="onActionClick('delete', rowData)"></button>
					<button *ngFor=" let action of options().showCustomActions ? customActions() : []" 
						pButton type="button" [icon]="action.icon" class="p-button-text" [ngClass]="action.styleClass"
						(click)="action.action(rowData)"></button>
				</td>
			</tr>
		</ng-template>

		<ng-template pTemplate="emptymessage">
			<tr>
				<td [attr.colspan]="
            visibleColumns().length +
            (showRowActions() ? 1 : 0) +
            (showCheckboxes() ? 1 : 0)
          ">
					{{ options().emptyMessage }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>